<template>
  <div class="TwStoreVender">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買台灣精選源頭工廠</a>
        <div v-if="addToCartCount > 0">
          <button
            type="button"
            class="btn btn-primary addCarButton"
            @click="goToShoppingCart()"
          >
            購物車
            <span class="badge badge-light">{{ addToCartCount }}</span>
          </button>
        </div>
        <button
          type="button"
          class="btn btn-primary addCarButton"
          @click="goToTwStore()"
        >
          回上一頁
        </button>
      </nav>
      <div class="alert alert-danger" role="alert">
        注意不能低於公開售價，如果發現低於廠商設定公開價格將會斷貨處理
      </div>
      <div class="row">
        <div class="col-12 col-sm-12">
          <div class="card">
            <img
              v-lazy="currentDisplayView.main_image"
              class="card-img-top"
              alt
            />
            <div class="card-body">
              <h5 class="card-title">{{ currentDisplayView.product_name }}</h5>
              <p class="card-text">
                起批數:{{ currentDisplayView.price.limit_quantity_l1 }}
              </p>
              <p class="card-text">
                免運費數量:{{ currentDisplayView.free_freight_quantity }}
              </p>
              <p class="card-text">成本價格:</p>
              <p class="card-text">
                ≥ {{ currentDisplayView.price.limit_quantity_l1 }}(數量):
                {{ currentDisplayView.price.price_l1 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ currentDisplayView.price.limit_quantity_l2 }} (數量):
                {{ currentDisplayView.price.price_l2 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ currentDisplayView.price.limit_quantity_l3 }} (數量):
                {{ currentDisplayView.price.price_l3 }}台幣
              </p>
              <p class="card-text">
                <b>公開售價:{{ currentDisplayView.price.pub_price }}台幣</b>
              </p>
              <p class="card-text">{{ currentDisplayView.sku[0].comment }}</p>
              <div class="col-12">
                <p>購買數量:</p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="lessAmounts(0)"
                    >
                      -
                    </button>
                  </div>
                  <input
                    type="number"
                    class="form-control"
                    placeholder
                    aria-label="inputAmounts"
                    v-model="selectQuantitys[0]"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="addAmounts(0)"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary btn-block"
                @click="addShoppingCart(currentDisplayView.product_id, 0)"
              >
                加入購物車
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <p>同工廠其他商品</p>
      <div class="row">
        <div
          class="col-12 col-sm-12"
          v-for="(product, index) in displayViews"
          v-bind:key="(product, index)"
        >
          <div class="card">
            <img v-bind:src="product.main_image" class="card-img-top" alt />
            <div class="card-body">
              <h5 class="card-title">{{ product.product_name }}</h5>
              <p class="card-text">
                起批數:{{ product.price.limit_quantity_l1 }}
              </p>
              <p class="card-text">
                免運費數量:{{ product.free_freight_quantity }}
              </p>
              <p class="card-text">價格:</p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l1 }}(數量):
                {{ product.price.price_l1 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l2 }} (數量):
                {{ product.price.price_l2 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l3 }} (數量):
                {{ product.price.price_l3 }}台幣
              </p>
              <p class="card-text">{{ product.sku[0].comment }}</p>
              <p class="card-text">
                公開售價:{{ product.price.pub_price }}台幣
              </p>
              <div class="col-12">
                <p>數量:</p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="lessAmounts(index + 1)"
                    >
                      -
                    </button>
                  </div>
                  <input
                    type="number"
                    class="form-control"
                    placeholder
                    aria-label="inputAmounts"
                    v-model="selectQuantitys[index + 1]"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="addAmounts(index + 1)"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary btn-block"
                @click="addShoppingCart(product.product_id, index + 1)"
              >
                加入購物車
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="fixedButton" v-if="addToCartCount > 0">
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          @click="goToShoppingCart()"
        >
          購物車
          <span class="badge badge-light">{{ addToCartCount }}</span>
        </button>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fixedButton {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
// import { isMobile } from "mobile-device-detect";
export default {
  name: 'TwStore',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      products: null,
      displayViews: null,
      currentDisplayView: null,
      isLoading: true,
      addToCartCount: 0,
      selectQuantitys: [],
    }
  },
  methods: {
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined ||
        localStorage.userImage == undefined ||
        localStorage.userName == undefined
      ) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        return true
      } else {
        return false
      }
    },
    GetTwProductByVenderId: function (venderId, currentProductId) {
      const vm = this
      ;(async function post() {
        let formData = {
          venderId: venderId,
        }
        await axios
          .post(vm.apiUrl + 'GetTwProductByValideVenderId', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            if (response.data != undefined) {
              vm.products = []
              vm.products = JSON.parse(JSON.stringify(response.data))
              vm.displayViews = []
              vm.currentDisplayView = {}
              response.data.forEach(product => {
                if (product.product_id != currentProductId) {
                  vm.displayViews.push(product)
                } else {
                  vm.currentDisplayView = JSON.parse(JSON.stringify(product))
                }
              })
              vm.isLoading = false
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '網路異常: ' + error,
              type: 'error',
            })
          })
      })()
    },
    addShoppingCart: function (productId, index) {
      const vm = this
      let products = []

      if (vm.selectQuantitys[index] == undefined) {
        vm.$toast.open({
          message: '請填寫數量!',
          type: 'error',
        })
        return
      }
      if (JSON.parse(localStorage.getItem('twProducts')) != undefined) {
        products = JSON.parse(localStorage.getItem('twProducts'))
      }

      vm.products.forEach(product => {
        if (product.product_id == productId) {
          if (vm.selectQuantitys[index] < product.price.limit_quantity_l1) {
            vm.$toast.open({
              message: '請填寫數量，不能低於起批數!',
              type: 'error',
            })
            return
          }
          //   if (
          //     products.filter(data => data.product_id === productId).length <= 0
          //   ) {

          let price = vm.priceByQuantity(product, vm.selectQuantitys[index])
          if (price == null) {
            vm.$toast.open({
              message: '系統有問題，請聯絡客服!-price',
              type: 'error',
            })
            return
          }
          product['select'] = {
            product_id: product.product_id,
            product_name: product.product_name,
            sku_name: product.sku[0].sku_name,
            size_name: product.sku[0].size_name,
            color_name: product.sku[0].color_name,
            quantity: vm.selectQuantitys[index],
            price: price,
          }

          products.push(product)

          vm.$toast.open({
            message: '「' + product.product_name + '」' + '成功加入購物車!',
            type: 'success',
          })
          //   } else {
          //     alert("商品已經加入購物車");
          //   }
        }
      })
      localStorage.setItem('twProducts', JSON.stringify(products))
      vm.addToCartCount = JSON.parse(localStorage.getItem('twProducts')).length
    },
    goToShoppingCart: function () {
      const vm = this
      if (vm.addToCartCount <= 0) {
        alert('請先加入商品到購物車!')
      } else {
        vm.$router.push('TwShoppingCart')
      }
    },
    addAmounts: function (index) {
      const vm = this
      if (vm.selectQuantitys[index] == undefined) {
        vm.selectQuantitys[index] = 1
      } else {
        vm.selectQuantitys[index] = vm.selectQuantitys[index] + 1
      }
      vm.$forceUpdate()
    },
    lessAmounts: function (index) {
      const vm = this
      if (vm.selectQuantitys[index] == undefined) {
        vm.selectQuantitys[index] = 1
      } else {
        if (vm.selectQuantitys[index] > 1) {
          vm.selectQuantitys[index] = vm.selectQuantitys[index] - 1
        }
      }
      vm.$forceUpdate()
    },
    priceByQuantity: function (product, quantity) {
      if (quantity >= product.price.limit_quantity_l3) {
        return product.price.price_l3
      } else if (quantity >= product.price.limit_quantity_l2) {
        return product.price.price_l2
      } else if (quantity >= product.price.limit_quantity_l1) {
        return product.price.price_l1
      } else {
        return null
      }
    },
    goToTwStore: function () {
      const vm = this
      vm.$router.push('twstore')
      localStorage.setItem('twProducts', JSON.stringify([]))
      vm.$forceUpdate()
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()
    if (
      localStorage.selectVenderId != undefined ||
      localStorage.selectProductId != undefined
    ) {
      vm.GetTwProductByVenderId(
        localStorage.selectVenderId,
        localStorage.selectProductId
      )
    }
    if (localStorage.getItem('twProducts') != undefined) {
      vm.addToCartCount = JSON.parse(localStorage.getItem('twProducts')).length
    }
  },
}
</script>
